import { request } from '@/common/utils/request'

export function getShopListFilter (params) { // 绩效考核方案指标项下发
  return request.get({
    url: 'feidian.perf.getShopListFilter',
    params
  }).then(res => res.data)
};

export function getIndicatorTabList (params) {
  return request.get({
    url: 'feidian.perf.getIndicatorTabList',
    params
  }).then(res => res.data)
}

export function getShopList (params) {
  return request.post({
    url: 'feidian.perf.getShopList',
    params
  }).then(res => res.data)
}

export function getBizoppFilter (params) { // 绩效考核方案指标项下发
  return request.get({
    url: 'feidian.bdapp.bizopp.getFilter',
    params
  }).then(res => res.data)
}
